import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Onlinecabbookingnavimumbaiairport() {



    const cardData = {

keyword: "Online Cab Booking Navi Mumbai Airport",

headingDescription:
    "Mumbai Airport Cab offers reliable and affordable Online Cab Booking Navi Mumbai Airport services for airport transfers, corporate travel, family trips, local rides, and outstation journeys. We provide a wide range of well-maintained vehicles including Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus with professional chauffeurs. With easy online booking, 24x7 availability, flight tracking support, transparent pricing, instant confirmation, and doorstep pickup and drop, we ensure a smooth, comfortable, and hassle-free travel experience from Navi Mumbai Airport to major destinations across Maharashtra.",

topPlaces: [
    {
        title: "Pune",
        description:
            "Pune is one of the most popular destinations from Navi Mumbai Airport, known for its IT parks, educational institutions, business hubs, and tourist attractions."
    },
    {
        title: "Lonavala",
        description:
            "Lonavala is a scenic hill station famous for waterfalls, valleys, caves, and pleasant weather, making it a preferred weekend getaway from Navi Mumbai Airport."
    },
    {
        title: "Nashik",
        description:
            "Nashik is known for Trimbakeshwar Jyotirlinga, vineyards, and spiritual tourism, attracting both pilgrims and leisure travelers."
    },
    {
        title: "Shirdi",
        description:
            "Shirdi is one of India’s most visited pilgrimage destinations dedicated to Sai Baba, making it a highly booked cab route from Navi Mumbai Airport."
    },
    {
        title: "Mahabaleshwar",
        description:
            "Mahabaleshwar is a popular hill station known for strawberry farms, scenic viewpoints, lakes, and cool weather throughout the year."
    },
    {
        title: "Goa",
        description:
            "Goa is a favorite long-distance travel destination known for beaches, nightlife, water sports, and coastal attractions."
    },
    {
        title: "Kolhapur",
        description:
            "Kolhapur is famous for Mahalaxmi Temple, cultural heritage, and traditional cuisine, making it a preferred pilgrimage and family travel destination."
    },
    {
        title: "Aurangabad",
        description:
            "Aurangabad attracts tourists with Ajanta and Ellora Caves, Bibi Ka Maqbara, and rich historical significance."
    },
    {
        title: "Ratnagiri",
        description:
            "Ratnagiri is a beautiful Konkan destination known for Ganpatipule Temple, beaches, forts, and scenic coastal landscapes."
    },
    {
        title: "Saputara",
        description:
            "Saputara is a popular hill station near the Maharashtra-Gujarat border known for lakes, ropeway rides, viewpoints, and natural beauty."
    }
],



services: [
{
name: "Online Cab Booking Navi Mumbai Airport",
description: "Mumbai Airport Cab offers Online Cab Booking Navi Mumbai Airport service for passengers looking for fast, convenient, and reliable airport transportation. Whether you require an airport pickup, airport drop, local transfer, outstation journey, business travel, family ride, or group transportation, our online booking platform makes the process simple and hassle-free. We provide a wide range of vehicles including Sedan, SUV, Innova, Innova Crysta, Ertiga, Kia Carens, and Tempo Traveller to suit every travel requirement. Our professional chauffeurs ensure punctual arrivals, safe driving, luggage assistance, and smooth transportation experience. With instant booking confirmation, transparent pricing, 24x7 customer support, and secure reservations, we make airport travel from Navi Mumbai Airport comfortable, affordable, and stress-free for every passenger."
},
{
name: "Navi Mumbai Airport Online Cab Booking",
description: "Navi Mumbai Airport Online Cab Booking service provides a simple and efficient way to reserve airport transportation in advance. Mumbai Airport Cab offers quick booking confirmation, multiple vehicle choices, professional chauffeurs, and reliable service to ensure comfortable airport transfers for business travellers, families, tourists, and corporate clients."
},
{
name: "Book Cab Online Navi Mumbai Airport",
description: "Book Cab Online Navi Mumbai Airport service allows passengers to arrange airport transportation within minutes through an easy booking process. Mumbai Airport Cab provides flexible travel options, transparent pricing, clean vehicles, and experienced drivers to ensure safe and convenient airport transfers at any time of the day."
},
{
name: "Navi Mumbai Airport Cab Booking Online",
description: "Navi Mumbai Airport Cab Booking Online service helps travellers secure confirmed airport transportation before arrival or departure. Mumbai Airport Cab ensures professional service, timely vehicle availability, comfortable travel experience, and dependable airport transfers for local and outstation destinations."
},
{
name: "Online Taxi Booking Navi Mumbai Airport",
description: "Online Taxi Booking Navi Mumbai Airport service provides convenient taxi reservations for airport pickups and drops. Mumbai Airport Cab offers comfortable air-conditioned vehicles, professional chauffeurs, easy booking options, and reliable transportation solutions for passengers travelling to or from the airport."
},
{
name: "Best Online Cab Booking Navi Mumbai Airport",
description: "Best Online Cab Booking Navi Mumbai Airport service delivers premium airport transportation with reliable drivers, modern vehicles, and excellent customer support. Mumbai Airport Cab focuses on passenger comfort, punctual service, and smooth airport transfers for a superior travel experience."
},
{
name: "Cheap Online Cab Booking Navi Mumbai Airport",
description: "Cheap Online Cab Booking Navi Mumbai Airport service offers affordable airport transportation without compromising on safety, reliability, or comfort. Mumbai Airport Cab provides competitive pricing, clean vehicles, professional chauffeurs, and dependable service for budget-conscious travellers."
},
{
name: "Reliable Online Cab Booking Navi Mumbai Airport",
description: "Reliable Online Cab Booking Navi Mumbai Airport service ensures passengers receive confirmed bookings, punctual pickups, and professional transportation support. Mumbai Airport Cab focuses on dependable service, experienced drivers, and comfortable vehicles for seamless airport travel."
},
{
name: "Instant Cab Booking Navi Mumbai Airport",
description: "Instant Cab Booking Navi Mumbai Airport service provides immediate vehicle availability for urgent airport transportation needs. Mumbai Airport Cab offers fast booking confirmation, nearby driver allocation, and efficient travel solutions for last-minute airport transfers."
},
{
name: "Advance Cab Booking Navi Mumbai Airport",
description: "Advance Cab Booking Navi Mumbai Airport service allows passengers to schedule airport transportation well before their travel date. Mumbai Airport Cab ensures vehicle availability, timely dispatch, and smooth airport transfers with professional chauffeurs."
},
{
name: "24x7 Online Cab Booking Navi Mumbai Airport",
description: "24x7 Online Cab Booking Navi Mumbai Airport service provides round-the-clock access to airport transportation. Mumbai Airport Cab operates throughout the day and night, ensuring reliable service for early morning flights, midnight arrivals, and all airport travel requirements."
},
{
name: "Late Night Online Cab Booking Navi Mumbai Airport",
description: "Late Night Online Cab Booking Navi Mumbai Airport service offers safe and dependable transportation during late-night and overnight travel hours. Mumbai Airport Cab provides experienced chauffeurs, secure travel arrangements, and comfortable vehicles for stress-free airport journeys."
},
{
name: "Early Morning Online Cab Booking Navi Mumbai Airport",
description: "Early Morning Online Cab Booking Navi Mumbai Airport service ensures timely transportation for passengers with early flight departures. Mumbai Airport Cab provides punctual pickups, professional drivers, and reliable travel planning to help travellers reach the airport on time."
},
{
name: "Instant Airport Cab Booking Navi Mumbai Airport",
description: "Instant Airport Cab Booking Navi Mumbai Airport service is designed for travellers requiring quick transportation arrangements. Mumbai Airport Cab offers immediate booking confirmation, rapid vehicle dispatch, and smooth airport transfer services for urgent travel needs."
},
{
name: "Best Online Airport Cab Booking Navi Mumbai Airport",
description: "Best Online Airport Cab Booking Navi Mumbai Airport service combines convenience, reliability, and passenger comfort. Mumbai Airport Cab provides premium airport transportation with experienced chauffeurs, clean vehicles, and excellent customer support for a seamless travel experience."
},
{
name: "Cheap Online Airport Cab Booking Navi Mumbai Airport",
description: "Cheap Online Airport Cab Booking Navi Mumbai Airport service offers economical airport transportation solutions for individuals, families, and business travellers. Mumbai Airport Cab ensures affordable fares, dependable service, and comfortable travel without hidden charges."
},
{
name: "24x7 Airport Cab Booking Navi Mumbai Airport",
description: "24x7 Airport Cab Booking Navi Mumbai Airport service guarantees transportation availability at all times. Mumbai Airport Cab provides dependable airport pickups and drops with professional drivers and well-maintained vehicles regardless of flight schedules."
},
{
name: "Airport Pickup Online Cab Booking Navi Mumbai",
description: "Airport Pickup Online Cab Booking Navi Mumbai service allows passengers to reserve airport pickup services in advance. Mumbai Airport Cab tracks flight schedules, provides timely driver allocation, and ensures smooth transfers from the airport to any destination."
},
{
name: "Online Airport Transfer Navi Mumbai",
description: "Online Airport Transfer Navi Mumbai service provides complete airport transportation solutions for local, corporate, family, and outstation travel. Mumbai Airport Cab ensures professional chauffeurs, comfortable vehicles, punctual service, and hassle-free airport transfers for every passenger."
}
],

tableData: [
["Online Cab Booking Navi Mumbai Airport","Navi Mumbai Airport Online Cab Booking"],
["Book Cab Online Navi Mumbai Airport","Navi Mumbai Airport Cab Booking Online"],
["Online Taxi Booking Navi Mumbai Airport","Best Online Cab Booking Navi Mumbai Airport"],
["Cheap Online Cab Booking Navi Mumbai Airport","Reliable Online Cab Booking Navi Mumbai Airport"],
["Instant Cab Booking Navi Mumbai Airport","Advance Cab Booking Navi Mumbai Airport"],
["24x7 Online Cab Booking Navi Mumbai Airport","Late Night Online Cab Booking Navi Mumbai Airport"],
["Early Morning Online Cab Booking Navi Mumbai Airport","Instant Airport Cab Booking Navi Mumbai Airport"],
["Best Online Airport Cab Booking Navi Mumbai Airport","Cheap Online Airport Cab Booking Navi Mumbai Airport"],
["24x7 Airport Cab Booking Navi Mumbai Airport","Airport Pickup Online Cab Booking Navi Mumbai"],
["Online Airport Transfer Navi Mumbai","Online Cab Booking Navi Mumbai Airport"]
],












whychoose: [
    {
        WhyChooseheading: "Easy Online Cab Booking Navi Mumbai Airport",
        WhyChoosedescription: "Mumbai Airport Cabs provides quick and reliable online cab booking services for Navi Mumbai Airport transfers, ensuring a smooth and hassle-free travel experience."
    },
    {
        WhyChooseheading: "Instant Airport Pickup and Drop Service",
        WhyChoosedescription: "Passengers can conveniently pre-book cabs online for airport pickups and drops, avoiding last-minute transportation challenges."
    },
    {
        WhyChooseheading: "Perfect for Business and Frequent Travelers",
        WhyChoosedescription: "Corporate professionals, executives, and frequent flyers prefer our online booking system for fast confirmations and dependable airport transportation."
    },
    {
        WhyChooseheading: "Wide Range of Vehicle Options",
        WhyChoosedescription: "Customers can choose Sedan cars, Ertiga, Innova, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, Mini Buses, and premium vehicles according to passenger count and luggage requirements."
    },
    {
        WhyChooseheading: "Local and Outstation Airport Transfers",
        WhyChoosedescription: "Book cabs online for destinations within Mumbai or directly to Pune, Nashik, Shirdi, Lonavala, Mahabaleshwar, Surat, Ahmedabad, and other cities."
    },
    {
        WhyChooseheading: "Flight Tracking and Real-Time Coordination",
        WhyChoosedescription: "Our team monitors flight schedules and adjusts pickup timings to ensure timely service even when flights are delayed."
    },
    {
        WhyChooseheading: "Professional Drivers and Well-Maintained Vehicles",
        WhyChoosedescription: "Our experienced chauffeurs and regularly maintained vehicles ensure safe, comfortable, and reliable transportation."
    },
    {
        WhyChooseheading: "Ideal for Families, Tourists, and Corporate Groups",
        WhyChoosedescription: "Whether traveling alone, with family, or in a group, we provide suitable airport transportation solutions for every requirement."
    }
]
};

const faqData = [
    {
        question: "What is Online Cab Booking Navi Mumbai Airport?",
        answer: "Online Cab Booking Navi Mumbai Airport allows passengers to reserve airport pickup and drop cabs in advance through phone, WhatsApp, or online inquiry platforms."
    },
    {
        question: "Can I pre-book a cab before my flight arrives?",
        answer: "Yes, customers can book airport cabs in advance to ensure timely pickup and smooth transportation."
    },
    {
        question: "Which vehicles are available for online booking?",
        answer: "Sedan cars, Ertiga, Innova, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, Mini Buses, and premium vehicles are available."
    },
    {
        question: "Do you provide airport pickup and drop services?",
        answer: "Yes, both airport pickup and drop services are available for domestic and international passengers."
    },
    {
        question: "Can I book a cab for outstation travel from Navi Mumbai Airport?",
        answer: "Yes, customers can directly book cabs from Navi Mumbai Airport to Pune, Nashik, Shirdi, Lonavala, Mahabaleshwar, Surat, Ahmedabad, and other destinations."
    },
    {
        question: "Are Tempo Travellers available for group bookings?",
        answer: "Yes, Tempo Travellers and Mini Buses are available for family groups, tourists, wedding guests, and corporate teams."
    },
    {
        question: "Will my driver wait if the flight is delayed?",
        answer: "Yes, flight schedules are monitored and pickup timings are adjusted according to actual arrival times."
    },
    {
        question: "Can corporate companies use online airport cab booking services?",
        answer: "Yes, many organizations use our airport transportation services for executives, employees, and visiting clients."
    },
    {
        question: "Is advance booking recommended?",
        answer: "Yes, advance booking helps secure your preferred vehicle and ensures a smooth airport transfer experience."
    },
    {
        question: "How can I book a Navi Mumbai Airport Cab online?",
        answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cabs."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Rohan Merchant",
        feedback:
            "I booked my airport transfer online and received immediate confirmation. The cab arrived on time, and the entire experience was professional and hassle-free.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Shweta Jain",
        feedback:
            "The online booking process was simple and convenient. Our family airport pickup was perfectly coordinated, and the vehicle was clean and spacious.",
        rating: 5
    }
];



























   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];












const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Online Cab Booking Navi Mumbai Airport",
"image": "https://www.mumbaiairportcabs.com/assets/images/online-cab-booking-navi-mumbai-airport.jpg",
"description": "Book online cab service for Navi Mumbai Airport with instant confirmation, safe rides, and professional drivers. Mumbai Airport Cabs offers 24x7 airport pickup and drop taxi service for local and outstation travel.",
"brand": {
"@type": "Brand",
"name": "Mumbai Airport Cabs"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.mumbaiairportcabs.com/online-cab-booking-navi-mumbai-airport"
}
};




    return (
        <div>



<Helmet>
  <title>Online Cab Booking Navi Mumbai Airport | Instant Taxi Booking | +91 9545731161</title>

<meta
 name="description"
 content="Book online cab for Navi Mumbai Airport with instant confirmation. Safe, affordable, and 24x7 taxi booking service for airport transfers and outstation trips."
/>

<meta
 name="keywords"
 content="online cab booking navi mumbai airport, navi mumbai airport online cab booking, book cab online navi mumbai airport, navi mumbai airport cab booking online, online taxi booking navi mumbai airport, best online cab booking navi mumbai airport, cheap online cab navi mumbai airport"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>








            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/32.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Onlinecabbookingnavimumbaiairport;